(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["airrobo-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(root) {
    root.querySelectorAll('.ar-nav').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const desktop = nav.classList.contains('ar-nav--desktop');
      const parents = [...nav.querySelectorAll('.ar-nav__parent')];
      parents.forEach(parent => {
        parent.addEventListener('toggle', () => {
          if (parent.open) parents.forEach(other => { if (other !== parent) other.open = false; });
        });
        parent.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            parent.open = false;
            parent.querySelector('summary').focus();
            event.stopPropagation();
          }
        });
        if (desktop) {
          parent.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') parent.open = true;
          });
          parent.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse' && !parent.contains(document.activeElement)) parent.open = false;
          });
          parent.addEventListener('focusout', event => {
            if (!parent.contains(event.relatedTarget)) parent.open = false;
          });
        }
      });
      if (desktop) {
        nav.querySelectorAll('.ar-nav__categories').forEach(group => {
          const categories = [...group.querySelectorAll('.ar-nav__category')];
          categories.forEach(category => {
            const summary = category.querySelector('summary');
            function select() {
              categories.forEach(other => { other.open = other === category; });
              const panel = category.querySelector('.ar-nav__panel');
              group.style.minHeight = Math.max(panel.scrollHeight, 450) + 'px';
            }
            summary.addEventListener('click', event => { event.preventDefault(); select(); });
            summary.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') select(); });
            summary.addEventListener('focus', select);
          });
          const observer = new ResizeObserver(() => {
            const panel = group.querySelector('.ar-nav__category[open] .ar-nav__panel');
            if (panel) group.style.minHeight = Math.max(panel.scrollHeight, 450) + 'px';
          });
          group.querySelectorAll('.ar-nav__panel').forEach(panel => observer.observe(panel));
        });
      }
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.ar-nav--desktop .ar-nav__parent[open]').forEach(parent => {
      if (!parent.contains(event.target)) parent.open = false;
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
